require('./_wks-define')('observable');



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/library/modules/es7.symbol.observable.js